import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBookmark1 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 18 18",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "m9 12.75 6 3.75v-15H3v15zm-4.5 1.044L9 10.98l4.5 2.813V3h-9z",
		clipRule: "evenodd"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M12 6H6V4.5h6z",
		clipRule: "evenodd"
	})]
});
export default SvgBookmark1;
